import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, DialogContent, DialogContentText, DialogTitle, Divider, List, ListItem, ListItemText, Typography } from "@mui/material";
import { FC, ReactNode } from "react";
import theme from "src/theme/light";

export interface GenericList {
    nome: string;
}

export interface DadosFinalizar {
    data_atual: string,
    data_disponibilidade?: string,
    confirmado_em?: Date | string,
    user_id?: number | string,
    acessorios?: GenericList[],
    estruturas?: GenericList[],
    label?: ReactNode,
    migrado?: boolean,
    texto_aceito?: string,
    user_name?: string,
}

export interface TermosFinalizarProperties {
    termos: DadosFinalizar,
}

export const BASE_OBS = "OBS.: Projetos com financiamento bancário podem variar de acordo com o tempo de aprovação da instituição financeira."

const TermosFinalizar: FC<TermosFinalizarProperties> = ({ termos }) => {

    const {
        data_disponibilidade,
        data_atual,
        acessorios,
        estruturas,
        label, 
        migrado,
        texto_aceito,
    } = termos;

    return (
        <>
            {!migrado && data_disponibilidade && (
                <Box>
                    <DialogTitle style={{color: "#444444"}} className="titulo-termos-finalizar">
                        <h3 style={{ margin: '5px 0', fontWeight: 'normal' }}>Atenção!</h3>
                    </DialogTitle>
                    <Divider style={{height:"1px", backgroundColor: "grey"}} />
                    <DialogContent>
                        {(!acessorios?.length && !estruturas?.length) ? (
                            <>
                                <Typography variant="body1" style={{marginBottom: "10px"}}>
                                    O faturamento será realizado até <strong style={{ color: theme.palette.primary.main }}>{data_disponibilidade}</strong>, caso o pagamento seja reconhecido hoje (<strong style={{ color: theme.palette.primary.main }}>{data_atual}</strong>), podendo ser antecipado de acordo com a disponibilidade.
                                </Typography>
                                <Typography variant="body1"><strong>OBS.: Para projetos com financiamento bancário, o prazo está condicionado à liberação dos recursos pela instituição financeira.</strong></Typography>
                            </>
                        ):(<>
                            <DialogContentText style={{color: "#444444"}}>
                                A emissão da nota fiscal e a saída do material da fábrica desse projeto ocorrerão até <strong style={{ color: theme.palette.primary.main }}>{data_disponibilidade}</strong>,
                                podendo ser antecipadas de acordo com a disponibilidade. Caso o pagamento não seja reconhecido
                                hoje (<strong style={{ color: theme.palette.primary.main }}>{data_atual}</strong>), considerar a previsão informada no momento do pagamento.
                            </DialogContentText>
                            <DialogContentText style={{fontWeight: "bold", color:"#444444"}}>
                                {BASE_OBS}
                            </DialogContentText>
                        </>
                        )}
                        {((acessorios && acessorios.length > 0) || (estruturas && estruturas.length > 0)) && (
                            <>
                                <DialogContentText style={{ fontSize:"20px", color:"black", fontWeight:"normal", textAlign: "center"}}>
                                    Tem certeza?
                                </DialogContentText>
                                <List>
                                    <ListItemText style={{alignSelf:"flex-start", color:"#444444"}} primary={(
                                        <span>Os seguintes componentes <strong>não</strong> serão incluídos na solução, pois estão com quantidade zero:</span>
                                    )}/>
                                    {acessorios && (
                                    <>
                                        {acessorios.map((itm:any)=>{
                                            return(
                                                <ListItem>
                                                    <FontAwesomeIcon size={"xs"} icon={faCircle} style={{fontSize: "5px"}}/>
                                                    &nbsp;
                                                    <ListItemText style={{alignSelf:"flex-start", color:"#444444"}} primary={itm.nome} />
                                                </ListItem>
                                            )
                                        })}
                                        <Divider />
                                    </>)}
                                    {estruturas && (
                                    <>
                                        {estruturas.map((itm:any)=>{
                                            return(
                                                <ListItem>
                                                    <FontAwesomeIcon size={"xs"} icon={faCircle} style={{fontSize: "5px"}}/>
                                                    &nbsp;
                                                    <ListItemText style={{alignSelf:"flex-start", color:"#444444"}} primary={itm.nome} />
                                                </ListItem>
                                            )
                                        })}
                                        <Divider />
                                    </>)}                 
                                </List>
                            </>
                        )}

                        {label ? label : <></>}
                    </DialogContent>
                </Box>
            )}

            {migrado && texto_aceito && <div dangerouslySetInnerHTML={{ __html: (texto_aceito || "") }} />}
        </>
    )
}

export { TermosFinalizar };